export default function MySQL_ISNULL() {
  return (
    <div>
      <h2>MySQL_ISNULL</h2>    </div>
  );
}